export type Faq = {
  id: string
  question: string
  answer: string
  clientData?: boolean
}

export const faqs: Faq[] = [
  {
    id: 'whatsapp',
    question: '¿Puedo escribir por WhatsApp antes de agendar?',
    answer:
      'Sí. Es la forma más directa de contactarnos. Cuéntanos lo que necesitas y te orientamos antes de coordinar tu visita.',
  },
  {
    id: 'costo',
    question: '¿La valoración inicial tiene costo?',
    answer:
      'En esta demostración, el costo se define según cada consultorio real. Esta información debe comunicarse con total claridad en la página del cliente.',
    clientData: true,
  },
  {
    id: 'urgencias',
    question: '¿Atienden urgencias odontológicas?',
    answer:
      'Si tienes dolor o una situación que no puede esperar, escríbenos por WhatsApp y te orientamos sobre el manejo inicial y disponibilidad.',
  },
  {
    id: 'anticipacion',
    question: '¿Con cuánta anticipación debo agendar?',
    answer:
      'Depende de la disponibilidad del consultorio. Para valoraciones iniciales, generalmente hay opciones en los próximos días.',
  },
  {
    id: 'pagos',
    question: '¿Hay facilidades de pago?',
    answer:
      'Las condiciones de pago dependen de cada consultorio. Este es uno de los datos más relevantes para incluir con transparencia.',
    clientData: true,
  },
  {
    id: 'primera-cita',
    question: '¿Qué debo llevar a mi primera cita?',
    answer:
      'Generalmente tu documento de identidad y, si los tienes, radiografías o diagnósticos previos. Tu profesional te indicará cualquier requerimiento específico.',
  },
  {
    id: 'ninos',
    question: '¿Atienden niños?',
    answer:
      'Este dato también es específico de cada consultorio. Debe responderse claramente indicando rango de edad y servicios de odontopediatría si aplica.',
    clientData: true,
  },
]
